import { z } from 'zod';
/** admin/customer 공통. */
export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z
        .string()
        .min(12, '비밀번호는 12자 이상이어야 합니다.')
        .max(200),
});
//# sourceMappingURL=account.js.map